import { RouteRecordRaw } from "vue-router";

export const authRouter: RouteRecordRaw = {
  path: "/",
  component: () => import("@/components/page-layouts/Auth.vue"),
  children: [
    {
      path: "/sign-in",
      name: "sign-in",
      component: () => import("@/views/authentication/basic-flow/SignIn.vue"),
    },
    {
      path: "/sign-up",
      name: "sign-up",
      component: () => import("@/views/authentication/basic-flow/SignUp.vue"),
    },
    {
      path: "/password-reset",
      name: "password-reset",
      component: () =>
        import("@/views/authentication/basic-flow/PasswordReset.vue"),
    },
  ],
};
